var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderBottomRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 10.7002C8.01887 10.7002 8.03354 10.6855 8.03354 10.6668C8.03354 10.6482 8.01887 10.6335 8.0002 10.6335C7.98154 10.6335 7.96687 10.6482 7.96687 10.6668C7.96687 10.6855 7.98154 10.7002 8.0002 10.7002",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 5.36667C8.01887 5.36667 8.03354 5.352 8.03354 5.33333C8.03354 5.31467 8.01887 5.3 8.0002 5.3C7.98154 5.3 7.96687 5.31467 7.96687 5.33333C7.96687 5.352 7.98154 5.36667 8.0002 5.36667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 8.03341C8.01887 8.03341 8.03354 8.01875 8.03354 8.00008C8.03354 7.98141 8.01887 7.96675 8.0002 7.96675C7.98154 7.96675 7.96687 7.98141 7.96687 8.00008C7.96687 8.01875 7.98154 8.03341 8.0002 8.03341",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30018 8.00008C5.30018 8.01875 5.31485 8.03341 5.33352 8.03341C5.35218 8.03341 5.36685 8.01875 5.36685 8.00008C5.36685 7.98141 5.35218 7.96675 5.33352 7.96675C5.31485 7.96675 5.30018 7.98141 5.30018 8.00008",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66689 8.03341C2.68556 8.03341 2.70022 8.01875 2.70022 8.00008C2.70022 7.98141 2.68556 7.96675 2.66689 7.96675C2.64822 7.96675 2.63356 7.98141 2.63356 8.00008C2.63356 8.01875 2.64822 8.03341 2.66689 8.03341",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6336 8.00008C10.6336 8.01875 10.6482 8.03341 10.6669 8.03341C10.6856 8.03341 10.7002 8.01875 10.7002 8.00008C10.7002 7.98141 10.6856 7.96675 10.6669 7.96675C10.6482 7.96675 10.6336 7.98141 10.6336 8.00008",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66689 10.7002C2.68556 10.7002 2.70022 10.6855 2.70022 10.6668C2.70022 10.6482 2.68556 10.6335 2.66689 10.6335C2.64822 10.6335 2.63356 10.6482 2.63356 10.6668C2.63356 10.6855 2.64822 10.7002 2.66689 10.7002",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66689 5.36667C2.68556 5.36667 2.70022 5.352 2.70022 5.33333C2.70022 5.31467 2.68556 5.3 2.66689 5.3C2.64822 5.3 2.63356 5.31467 2.63356 5.33333C2.63356 5.352 2.64822 5.36667 2.66689 5.36667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30018 13.3333C5.30018 13.352 5.31485 13.3667 5.33352 13.3667C5.35218 13.3667 5.36685 13.352 5.36685 13.3333C5.36685 13.3147 5.35218 13.3 5.33352 13.3C5.31485 13.3 5.30018 13.3147 5.30018 13.3333",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66689 13.3667C2.68556 13.3667 2.70022 13.352 2.70022 13.3333C2.70022 13.3147 2.68556 13.3 2.66689 13.3C2.64822 13.3 2.63356 13.3147 2.63356 13.3333C2.63356 13.352 2.64822 13.3667 2.66689 13.3667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 2.70016C8.01887 2.70016 8.03354 2.6855 8.03354 2.66683C8.03354 2.64816 8.01887 2.6335 8.0002 2.6335C7.98154 2.6335 7.96687 2.64816 7.96687 2.66683C7.96687 2.6855 7.98154 2.70016 8.0002 2.70016",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30018 2.66683C5.30018 2.6855 5.31485 2.70016 5.33352 2.70016C5.35218 2.70016 5.36685 2.6855 5.36685 2.66683C5.36685 2.64816 5.35218 2.6335 5.33352 2.6335C5.31485 2.6335 5.30018 2.64816 5.30018 2.66683",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6336 2.66683C10.6336 2.6855 10.6482 2.70016 10.6669 2.70016C10.6856 2.70016 10.7002 2.6855 10.7002 2.66683C10.7002 2.64816 10.6856 2.6335 10.6669 2.6335C10.6482 2.6335 10.6336 2.64816 10.6336 2.66683",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66689 2.70016C2.68556 2.70016 2.70022 2.6855 2.70022 2.66683C2.70022 2.64816 2.68556 2.6335 2.66689 2.6335C2.64822 2.6335 2.63356 2.64816 2.63356 2.66683C2.63356 2.6855 2.64822 2.70016 2.66689 2.70016",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 5.3C13.3148 5.3 13.3002 5.31467 13.3002 5.33333C13.3002 5.352 13.3148 5.36667 13.3335 5.36667C13.3522 5.36667 13.3668 5.352 13.3668 5.33333C13.3668 5.31467 13.3522 5.3 13.3335 5.3",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 2.6333C13.3148 2.6333 13.3002 2.64797 13.3002 2.66663C13.3002 2.6853 13.3148 2.69997 13.3335 2.69997C13.3522 2.69997 13.3668 2.6853 13.3668 2.66663C13.3668 2.64797 13.3522 2.6333 13.3335 2.6333",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 13.2799V7.67993",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76013 13.3201H13.3601",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderBottomRight);
export default ForwardRef;